<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { RouterLink } from 'vue-router'
import { useAgentChannelsStore } from '../../stores/agent_channels'

const props = defineProps<{ channelId: number }>()

const store = useAgentChannelsStore()
const channel = computed(() => store.channels.find((c) => c.id === props.channelId) ?? null)

onMounted(() => {
  if (!store.channelsLoaded) void store.fetchChannels()
})
</script>

<template>
  <RouterLink
    :to="{ name: 'channels', query: { channel: props.channelId } }"
    class="text-white/70 no-underline hover:underline"
    data-testid="agent-home-channel-link"
    >#{{ channel?.name ?? props.channelId }}</RouterLink
  >
</template>
